import { render } from "./DownloadInscriptionsCSV.vue?vue&type=template&id=60558686"
import script from "./DownloadInscriptionsCSV.vue?vue&type=script&lang=js"
export * from "./DownloadInscriptionsCSV.vue?vue&type=script&lang=js"

import "./DownloadInscriptionsCSV.vue?vue&type=style&index=0&id=60558686&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__